import { InternalLinkTypeEnum } from '@rsc/models/InternalLinkTypeEnum';
import generateProductSlug from '@rsc/utils/generateProductSlug';
import { GetInternalLinkFunctionType } from '@rsc/models/GetInternalLinkFunctionType';
import { LocaleCurrencyEnum } from '@rsc/models/LocaleCurrencyEnum';
import {
  SanityBlogPost,
  SanityCollection,
  SanityPage,
  SanityPerson,
  SanityPressRelease,
  SanityProduct,
} from '@rsc/models/gatsby-graphql-types';

const getTranslatedSlug = (
  slug: string,
  currency?: string,
  anchor?: string
) => {
  let localeSlug = slug;

  if (currency === LocaleCurrencyEnum.CAD) {
    localeSlug = `/en-ca${localeSlug}`;
  }

  // Check if Anchor exists and add it to the url
  if (anchor) {
    localeSlug = `${localeSlug}#${anchor}`;
  }

  return localeSlug;
};

const getInternalLink: GetInternalLinkFunctionType = ({
  reference,
  slug,
  currency,
  anchor,
}) => {
  if (slug) {
    return getTranslatedSlug(slug, currency, anchor);
  }

  // eslint-disable-next-line no-underscore-dangle
  switch (reference?._type) {
    case InternalLinkTypeEnum.PRODUCT:
      return getTranslatedSlug(
        `/${generateProductSlug({
          productHandle: (reference as SanityProduct).store.slug.current,
          productType: (reference as SanityProduct).store.productType,
        })}`,
        currency,
        anchor
      );

    case InternalLinkTypeEnum.PERSON:
      return getTranslatedSlug(
        `/people/${(reference as SanityPerson).slug.current}`,
        currency,
        anchor
      );

    case InternalLinkTypeEnum.PRESS_RELEASE:
      return getTranslatedSlug(
        `/press-releases/${(reference as SanityPressRelease).slug.current}`,
        currency
      );

    case InternalLinkTypeEnum.BLOG_POST:
      return getTranslatedSlug(
        `/blog/${(reference as SanityBlogPost).slug.current}`,
        currency,
        anchor
      );

    case InternalLinkTypeEnum.COLLECTION:
      return getTranslatedSlug(
        (reference as SanityCollection)?.store?.slug?.current === 'shop'
          ? `/${(reference as SanityCollection).store.slug.current}`
          : `/shop/${(reference as SanityCollection).store.slug.current}`,
        currency,
        anchor
      );

    default:
      return getTranslatedSlug(
        (reference as SanityPage)?.slug?.current
          ? `/${(reference as SanityPage).slug.current}`
          : '/',
        currency,
        anchor
      );
  }
};

export default getInternalLink;
